import React from 'react';
import { RefreshCw } from 'lucide-react';
import CategoryTabs from './CategoryTabs';

/**
 * MessageCategoryBar - Category tabs with scan button for messages
 */
const MessageCategoryBar = ({
  categories = [],
  activeCategory,
  onCategoryChange,
  onEditClick,
  formatLabel,
  onScan,
  className = ''
}) => {
  return (
    <div className={`flex-shrink-0 px-2 md:px-3 py-2 overflow-x-auto ${className}`}>
      <div className="flex gap-2 items-center">
        <CategoryTabs
          categories={categories}
          activeCategory={activeCategory}
          onCategoryChange={onCategoryChange}
          onEditClick={onEditClick}
          formatLabel={formatLabel}
          showEditButton={true}
        />
        
        {/* Scan/Rescan Button */}
        <button
          onClick={onScan}
          data-testid="scan-categories-btn"
          className="px-3 py-1.5 rounded-lg text-xs font-medium transition-all whitespace-nowrap bg-black text-white border border-gray-400 hover:bg-gray-900 flex items-center gap-1"
          title="Rescan messages to categorize"
        >
          <RefreshCw size={12} />
          Scan
        </button>
      </div>
    </div>
  );
};

export default MessageCategoryBar;
